export enum PartListColId {
  ALIAS = 'alias',
  COMPUTED_COST = 'computedCost',
  EXTENDED_COMPUTED_COST = 'extendedComputedCost',
  MANUFACTURER_NAME = 'manufacturerName',
  PACKAGING = 'packaging',
  PART = 'part',
  PART_DESCRIPTION = 'partDescription',
  QUANTITY = 'quantity',
  UOM = 'uom',
}
